export const getDisplayGameName = (game) => {
  const gameName = game?.gameName || "";
  const fullGameName = game?.fullGameName?.trim();

  return fullGameName ? `${gameName} - ${fullGameName}` : gameName;
};
